package ai.wagemix.logic.picker

import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * The analytics events of the occupation picker presenter (planning/analytics-plan.md §5, "Mix
 * building"). The search text is the only free text the site sends; the search field asks users
 * not to enter personal information.
 */

private inline fun FSLog.sendWMOccupationPickerEvent(
    eventName: String,
    crossinline fields: MutableMap<String, Any>.() -> Unit = {}
) {
    sendEventInclusive(severity = Severity.Info, eventName = eventName) {
        fields()
    }
}

/** [occupationCount] is the size of the draft the picker adds to. */
internal fun FSLog.sendWMOccupationPickerOpened(occupationCount: Int) {
    sendWMOccupationPickerEvent(eventName = "WMOccupationPickerOpened") {
        put("occupation_count", occupationCount)
    }
}

/** A search that settled; [resultCount] is the number of occupations it keeps. */
internal fun FSLog.sendWMOccupationSearched(query: String, resultCount: Int) {
    sendWMOccupationPickerEvent(eventName = "WMOccupationSearched") {
        put("query", query)
        put("query_length", query.length)
        put("result_count", resultCount)
    }
}

internal fun FSLog.sendWMOccupationsAdded(
    addedCount: Int,
    groupsAdded: Int,
    leavesAdded: Int,
    replacedCount: Int,
    occupationCount: Int,
) {
    sendWMOccupationPickerEvent(eventName = "WMOccupationsAdded") {
        put("added_count", addedCount)
        put("groups_added", groupsAdded)
        put("leaves_added", leavesAdded)
        put("replaced_count", replacedCount)
        put("occupation_count", occupationCount)
    }
}
